import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21437fcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create Booking", -1))
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Back to Availability ")
const _hoisted_4 = {
  key: 0,
  class: "booking-summary"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "success-actions" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" View Booking ")
const _hoisted_8 = {
  key: 3,
  class: "booking-review"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Booking Review", -1))
const _hoisted_10 = { class: "review-grid" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Guest Information", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Stay Details", -1))
const _hoisted_13 = ["onSubmit"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Guest Information", -1))
const _hoisted_15 = { class: "form-row" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Existing Guest ID (optional)", -1))
const _hoisted_18 = { class: "form-row" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "First Name", -1))
const _hoisted_21 = ["required"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Last Name", -1))
const _hoisted_24 = ["required"]
const _hoisted_25 = { class: "form-row" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Email", -1))
const _hoisted_28 = ["required"]
const _hoisted_29 = { class: "form-group" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Phone", -1))
const _hoisted_31 = ["required"]
const _hoisted_32 = { class: "form-row" }
const _hoisted_33 = { class: "form-group form-group--wide" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Street Address", -1))
const _hoisted_35 = ["required"]
const _hoisted_36 = { class: "form-row" }
const _hoisted_37 = { class: "form-group" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "City", -1))
const _hoisted_39 = ["required"]
const _hoisted_40 = { class: "form-group" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Postcode", -1))
const _hoisted_42 = ["required"]
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "State", -1))
const _hoisted_45 = ["required"]
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Country", -1))
const _hoisted_48 = ["required"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Country", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Stay Details", -1))
const _hoisted_51 = { class: "form-row" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Arrival Date", -1))
const _hoisted_54 = { class: "form-group" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Departure Date", -1))
const _hoisted_56 = { class: "form-row" }
const _hoisted_57 = { class: "form-group" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Adults", -1))
const _hoisted_59 = { class: "form-group" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Children", -1))
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Animals", -1))
const _hoisted_63 = ["disabled"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Guest Email Already Exists", -1))
const _hoisted_65 = { class: "duplicate-guest-review" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " A guest with this email already exists. Review both records before choosing how to continue. ", -1))
const _hoisted_67 = { class: "review-grid" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "New Guest Information", -1))
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Existing Guest Information", -1))
const _hoisted_70 = { class: "modal-actions" }
const _hoisted_71 = ["disabled"]
const _hoisted_72 = ["disabled"]
const _hoisted_73 = ["disabled"]

import { ref } from "vue";
import { useRoute } from "vue-router";
import api from "@virgodev/bazaar/functions/api";
import { countryOptions } from "@/utils/countryOptions";
import BaseModal from "@/components/BaseModal.vue";

type NbBookingCreatePayload = {
  facilityId: string;
  booking_site_id: number;
  booking_arrival: string;
  booking_departure: string;
  booking_adults: number;
  booking_children: number;
  booking_animals: number;
  guest_id?: number;
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  address_street?: string;
  address_city?: string;
  address_postcode?: string;
  address_state_name?: string;
  address_country_name?: string;
  tariffs_quoted?: Record<
    string,
    {
      tariff_applied_id?: number;
      price: number;
    }
  >;
};

type NbGuestDetail = {
  id?: string | number;
  guest_id?: string | number;
  guest_firstname?: string;
  guest_lastname?: string;
  firstname?: string;
  lastname?: string;
  guest_name?: string;
  name?: string;
  guest_email?: string;
  contact_email?: string;
  email?: string;
  guest_phone?: string;
  contact_phone?: string;
  phone?: string;
  guest_mobile?: string;
  mobile?: string;
  account_id?: string | number;
  street?: string;
  city?: string;
  state?: string;
  postcode?: string;
  country?: string;
  guest_address?: string;
  guest_city?: string;
  guest_state?: string;
  guest_postcode?: string;
  guest_country?: string;
  contact_details?: Array<{
    type?: string | null;
    content?: string | null;
  }>;
};

type DuplicateGuestAction = "create_new" | "overwrite_existing";


export default /*#__PURE__*/_defineComponent({
  props: {
    facilityId: null,
    facilityName: null
  },
  setup(__props: any) {

const props = __props as {
  facilityId: string;
  facilityName?: string;
}



const route = useRoute();
const siteId = ref((route.query.siteId as string) || "");
const siteName = ref((route.query.siteName as string) || "");
const arrival = ref((route.query.arrival as string) || "");
const departure = ref((route.query.departure as string) || "");
const adults = ref(Number(route.query.adults) || 1);
const children = ref(Number(route.query.children) || 0);
const animals = ref(Number(route.query.animals) || 0);
const price = ref((route.query.price as string) || "");
const rateTitle = ref((route.query.rateTitle as string) || "");
const tariffAppliedId = ref((route.query.tariffAppliedId as string) || "");
const discountCode = ref((route.query.discountCode as string) || "");

const guestId = ref("");
const firstName = ref("");
const lastName = ref("");
const email = ref("");
const phone = ref("");
const addressStreet = ref("");
const addressCity = ref("");
const addressPostcode = ref("");
const addressStateName = ref("");
const addressCountryName = ref("");

const submitting = ref(false);
const errorMessage = ref("");
const successMessage = ref("");
const createdBookingId = ref("");
const existingGuest = ref<NbGuestDetail | null>(null);
const duplicateGuest = ref<NbGuestDetail | null>(null);
const duplicateGuestAction = ref<DuplicateGuestAction | null>(null);

async function createBooking() {
  await submitBooking();
}

async function submitBooking(action?: DuplicateGuestAction) {
  if (!siteId.value) {
    errorMessage.value = "No site selected. Please go back to Availability.";
    return;
  }
  if (!arrival.value || !departure.value) {
    errorMessage.value = "Arrival and departure dates are required.";
    return;
  }
  if (!guestId.value) {
    const missingFields = requiredGuestFields()
      .filter((field) => !field.value.trim())
      .map((field) => field.label);
    if (missingFields.length) {
      errorMessage.value =
        "Please complete all guest information before creating the booking: " +
        missingFields.join(", ") +
        ".";
      return;
    }
  }

  submitting.value = true;
  errorMessage.value = "";
  successMessage.value = "";
  createdBookingId.value = "";
  existingGuest.value = null;
  const selectedDuplicateGuest = duplicateGuest.value;
  if (!action) {
    duplicateGuest.value = null;
  }

  try {
    if (!guestId.value && !action) {
      const matchingGuest = await findExistingGuestByEmail();
      if (matchingGuest) {
        duplicateGuest.value = matchingGuest;
        submitting.value = false;
        return;
      }
    }

    if (action === "overwrite_existing") {
      const overwriteGuest =
        selectedDuplicateGuest || (await findExistingGuestByEmail());
      if (!overwriteGuest) {
        errorMessage.value = "Could not find the existing guest to update.";
        submitting.value = false;
        return;
      }
      const overwriteGuestId = existingGuestId(overwriteGuest);
      if (!overwriteGuestId) {
        errorMessage.value = "Existing guest is missing a guest ID.";
        submitting.value = false;
        return;
      }
      await updateExistingGuest(overwriteGuest, overwriteGuestId);
      guestId.value = String(overwriteGuestId);
      existingGuest.value = overwriteGuest;
    }

    const payload = buildBookingPayload(action);
    const response = await api({
      url: `nb/bookings/?facilityId=${props.facilityId}`,
      method: "POST",
      json: payload,
    });

    if ("body" in response && [200, 201].includes(response.status)) {
      const bookingId = response.body?.data?.booking_id || "";
      createdBookingId.value = String(bookingId || "");
      if (guestId.value) {
        await loadExistingGuestReview();
      }
      successMessage.value = `Booking created successfully${
        bookingId ? " (Booking #" + bookingId + ")" : ""
      }.`;
    } else {
      const body = "body" in response ? response.body : undefined;
      errorMessage.value = body?.error || "Failed to create booking.";
    }
  } catch {
    errorMessage.value = "An error occurred while creating the booking.";
  }

  submitting.value = false;
}

function buildBookingPayload(action?: DuplicateGuestAction) {
  const payload: NbBookingCreatePayload = {
    facilityId: props.facilityId,
    booking_site_id: Number(siteId.value),
    booking_arrival: arrival.value + " 14:00:00",
    booking_departure: departure.value + " 10:00:00",
    booking_adults: adults.value,
    booking_children: children.value,
    booking_animals: animals.value,
  };
  const quotedTariffs = buildTariffsQuoted();
  if (quotedTariffs) {
    payload.tariffs_quoted = quotedTariffs;
  }

  if (guestId.value || action === "overwrite_existing") {
    payload.guest_id = Number(guestId.value);
  } else {
    if (firstName.value) payload.first_name = firstName.value;
    if (lastName.value) payload.last_name = lastName.value;
    if (email.value) payload.email = email.value;
    if (phone.value) payload.phone = phone.value;
    if (addressStreet.value) payload.address_street = addressStreet.value;
    if (addressCity.value) payload.address_city = addressCity.value;
    if (addressPostcode.value) payload.address_postcode = addressPostcode.value;
    if (addressStateName.value)
      payload.address_state_name = addressStateName.value;
    if (addressCountryName.value)
      payload.address_country_name = addressCountryName.value;
  }

  return payload;
}

async function findExistingGuestByEmail() {
  const searchEmail = email.value.trim();
  if (!searchEmail) {
    return null;
  }

  const qs = new URLSearchParams({
    facilityId: props.facilityId,
    search_query: searchEmail,
    data_limit: "20",
  });
  const response = await api({
    url: `nb/guests/?${qs}`,
    method: "GET",
  });
  if (!response.ok) {
    return null;
  }

  const data = response.body?.data || response.body || [];
  const guests = Array.isArray(data) ? data : [data];
  const normalizedEmail = searchEmail.toLowerCase();
  return (
    (await guestDetailByEmailMatch(
      (guests as NbGuestDetail[]).find(
        (guest) => guestEmail(guest).trim().toLowerCase() === normalizedEmail
      ) || null
    )) || null
  );
}

async function guestDetailByEmailMatch(match: NbGuestDetail | null) {
  if (!match) {
    return null;
  }

  const matchGuestId = existingGuestId(match);
  if (!matchGuestId) {
    return match;
  }

  try {
    const response = await api({
      url: `nb/guest/?facilityId=${props.facilityId}&guestId=${matchGuestId}`,
      method: "GET",
    });
    if (response.ok) {
      const data = response.body.data || response.body;
      return (Array.isArray(data) ? data[0] : data) as NbGuestDetail;
    }
  } catch {
    return match;
  }

  return match;
}

async function updateExistingGuest(
  guest: NbGuestDetail,
  overwriteGuestId: string | number
) {
  const json: Record<string, string | number> = {
    firstname: firstName.value,
    lastname: lastName.value,
    contact_email: email.value,
    contact_phone: phone.value,
    street: addressStreet.value,
    city: addressCity.value,
    postcode: addressPostcode.value,
    state: addressStateName.value,
    country: addressCountryName.value,
  };
  if (guest.account_id) {
    json.account_id = guest.account_id;
  }

  const response = await api({
    url: `nb/guest/?facilityId=${props.facilityId}&guestId=${overwriteGuestId}`,
    method: "PUT",
    json,
  });
  if (!response.ok) {
    const body = "body" in response ? response.body : undefined;
    throw new Error(body?.error || "Failed to update guest.");
  }
}

async function continueWithNewGuest() {
  duplicateGuestAction.value = "create_new";
  await submitBooking("create_new");
  duplicateGuest.value = null;
  duplicateGuestAction.value = null;
}

async function overwriteExistingGuest() {
  duplicateGuestAction.value = "overwrite_existing";
  await submitBooking("overwrite_existing");
  duplicateGuest.value = null;
  duplicateGuestAction.value = null;
}

function cancelDuplicateGuestReview() {
  if (submitting.value) {
    return;
  }
  duplicateGuest.value = null;
  duplicateGuestAction.value = null;
}

async function loadExistingGuestReview() {
  try {
    const response = await api({
      url: `nb/guest/?facilityId=${props.facilityId}&guestId=${guestId.value}`,
      method: "GET",
    });
    if (response.ok) {
      const data = response.body.data || response.body;
      existingGuest.value = (
        Array.isArray(data) ? data[0] : data
      ) as NbGuestDetail;
    }
  } catch {
    existingGuest.value = null;
  }
}

function requiredGuestFields() {
  return [
    { label: "First Name", value: firstName.value },
    { label: "Last Name", value: lastName.value },
    { label: "Email", value: email.value },
    { label: "Phone", value: phone.value },
    { label: "Street Address", value: addressStreet.value },
    { label: "City", value: addressCity.value },
    { label: "Postcode", value: addressPostcode.value },
    { label: "State", value: addressStateName.value },
    { label: "Country", value: addressCountryName.value },
  ];
}

function guestReviewRows() {
  if (guestId.value) {
    const guest = existingGuest.value;
    return [
      { label: "Existing Guest ID", value: guestId.value },
      { label: "Name", value: guest ? guestName(guest) : "" },
      { label: "Email", value: guest ? guestEmail(guest) : "" },
      { label: "Phone", value: guest ? guestPhone(guest) : "" },
      { label: "Mobile", value: guest ? guestMobile(guest) : "" },
      { label: "Address", value: guest ? guestAddress(guest) : "" },
    ];
  }
  return [
    { label: "First Name", value: firstName.value },
    { label: "Last Name", value: lastName.value },
    { label: "Email", value: email.value },
    { label: "Phone", value: phone.value },
    { label: "Street Address", value: addressStreet.value },
    { label: "City", value: addressCity.value },
    { label: "Postcode", value: addressPostcode.value },
    { label: "State", value: addressStateName.value },
    { label: "Country", value: addressCountryName.value },
  ];
}

function newGuestRows() {
  return [
    { label: "First Name", value: firstName.value },
    { label: "Last Name", value: lastName.value },
    { label: "Email", value: email.value },
    { label: "Phone", value: phone.value },
    { label: "Street Address", value: addressStreet.value },
    { label: "City", value: addressCity.value },
    { label: "Postcode", value: addressPostcode.value },
    { label: "State", value: addressStateName.value },
    { label: "Country", value: addressCountryName.value },
  ];
}

function existingGuestRows(guest: NbGuestDetail) {
  return [
    { label: "Guest ID", value: String(existingGuestId(guest) || "") },
    { label: "Name", value: guestName(guest) },
    { label: "Email", value: guestEmail(guest) },
    { label: "Phone", value: guestPhone(guest) },
    { label: "Mobile", value: guestMobile(guest) },
    { label: "Address", value: guestAddress(guest) },
  ];
}

function existingGuestId(row: NbGuestDetail) {
  return row.guest_id || row.id || guestId.value;
}

function guestFirstName(row: NbGuestDetail) {
  return row.guest_firstname || row.firstname || "";
}

function guestLastName(row: NbGuestDetail) {
  return row.guest_lastname || row.lastname || "";
}

function guestName(row: NbGuestDetail) {
  return (
    row.guest_name ||
    row.name ||
    [guestFirstName(row), guestLastName(row)].filter(Boolean).join(" ") ||
    `Guest ${existingGuestId(row)}`
  );
}

function contactDetail(row: NbGuestDetail, types: string[]) {
  const details = Array.isArray(row.contact_details) ? row.contact_details : [];
  const match = details.find((detail) =>
    types.includes((detail.type || "").toString().toLowerCase())
  );
  return match?.content || "";
}

function guestEmail(row: NbGuestDetail) {
  return (
    row.guest_email ||
    row.contact_email ||
    row.email ||
    contactDetail(row, ["email"])
  );
}

function guestPhone(row: NbGuestDetail) {
  return (
    row.guest_phone ||
    row.contact_phone ||
    row.phone ||
    contactDetail(row, ["phone", "telephone"])
  );
}

function guestMobile(row: NbGuestDetail) {
  return (
    row.guest_mobile || row.mobile || contactDetail(row, ["mobile", "cell"])
  );
}

function nestedAddressValue(row: NbGuestDetail, key: string) {
  const address = (row as Record<string, unknown>).address;
  if (!address || typeof address !== "object") return "";
  const value = (address as Record<string, unknown>)[key];
  return typeof value === "string" ? value : "";
}

function guestValue(row: NbGuestDetail, key: string) {
  const value = (row as Record<string, unknown>)[key];
  return typeof value === "string" || typeof value === "number"
    ? String(value)
    : "";
}

function firstKnownAddressValue(...values: Array<string | undefined>) {
  const present = values.filter((value) => value);
  return (
    present.find((value) => value?.trim().toLowerCase() !== "unknown") || ""
  );
}

function guestStreet(row: NbGuestDetail) {
  return firstKnownAddressValue(
    guestValue(row, "address_street"),
    row.street,
    nestedAddressValue(row, "street"),
    row.guest_address
  );
}

function guestCity(row: NbGuestDetail) {
  return firstKnownAddressValue(
    guestValue(row, "address_city"),
    row.city,
    nestedAddressValue(row, "city"),
    row.guest_city
  );
}

function guestState(row: NbGuestDetail) {
  return firstKnownAddressValue(
    guestValue(row, "state_name"),
    guestValue(row, "address_state_name"),
    row.state,
    nestedAddressValue(row, "state"),
    row.guest_state
  );
}

function guestPostcode(row: NbGuestDetail) {
  return firstKnownAddressValue(
    guestValue(row, "address_postcode"),
    row.postcode,
    nestedAddressValue(row, "postcode"),
    row.guest_postcode
  );
}

function guestCountry(row: NbGuestDetail) {
  return firstKnownAddressValue(
    guestValue(row, "country_name"),
    guestValue(row, "address_country_name"),
    row.country,
    nestedAddressValue(row, "country"),
    row.guest_country
  );
}

function guestAddress(row: NbGuestDetail) {
  return [
    guestStreet(row),
    guestCity(row),
    guestState(row),
    guestPostcode(row),
    guestCountry(row),
  ]
    .filter(Boolean)
    .join(", ");
}

function stayReviewRows() {
  return [
    { label: "Booking ID", value: createdBookingId.value },
    { label: "Site", value: siteName.value || siteId.value },
    { label: "Arrival", value: arrival.value },
    { label: "Departure", value: departure.value },
    { label: "Adults", value: String(adults.value) },
    { label: "Children", value: String(children.value) },
    { label: "Animals", value: String(animals.value) },
    { label: "Estimated Price", value: price.value ? `$${price.value}` : "" },
    { label: "Rate", value: rateTitle.value },
    { label: "Discount Code/Name", value: discountCode.value },
  ];
}

function buildTariffsQuoted() {
  const total = numericAmount(price.value);
  const nights = selectedNights();
  if (total === null || nights <= 0) return null;
  const dailyPrice = Number((total / nights).toFixed(2));
  const lastDayPrice = Number((total - dailyPrice * (nights - 1)).toFixed(2));
  const quoted: NonNullable<NbBookingCreatePayload["tariffs_quoted"]> = {};

  for (let i = 0; i < nights; i++) {
    const date = addDays(arrival.value, i);
    const row: { tariff_applied_id?: number; price: number } = {
      price: i === nights - 1 ? lastDayPrice : dailyPrice,
    };
    const appliedId = Number(tariffAppliedId.value);
    if (Number.isFinite(appliedId) && appliedId > 0) {
      row.tariff_applied_id = appliedId;
    }
    quoted[date] = row;
  }
  return quoted;
}

function selectedNights() {
  if (!arrival.value || !departure.value) return 0;
  const start = new Date(arrival.value + "T00:00:00");
  const end = new Date(departure.value + "T00:00:00");
  const diff = end.getTime() - start.getTime();
  return diff > 0 ? Math.round(diff / 86400000) : 0;
}

function addDays(date: string, days: number) {
  const parsed = new Date(date + "T00:00:00");
  parsed.setDate(parsed.getDate() + days);
  return parsed.toISOString().slice(0, 10);
}

function numericAmount(value: string | number | undefined | null) {
  if (value === undefined || value === null || value === "") return null;
  const parsed = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isFinite(parsed) ? parsed : null;
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RouterLink, {
        class: "btn",
        to: {
        name: 'nb_availability',
        params: { facilityId: __props.facilityId, facilityName: __props.facilityName },
      }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["to"]),
      (siteName.value && !successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h2", null, "Site: " + _toDisplayString(siteName.value), 1),
            _createElementVNode("p", null, _toDisplayString(arrival.value) + " to " + _toDisplayString(departure.value) + " — " + _toDisplayString(adults.value) + " adult(s), " + _toDisplayString(children.value) + " child(ren), " + _toDisplayString(animals.value) + " animal(s) ", 1),
            (price.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, [
                  _createTextVNode(" Estimated Price: $" + _toDisplayString(price.value), 1),
                  (rateTitle.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" (" + _toDisplayString(rateTitle.value) + ")", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (errorMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 1,
            variant: "danger",
            dismissible: "",
            onDismissed: _cache[0] || (_cache[0] = ($event: any) => (errorMessage.value = ''))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(errorMessage.value), 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (successMessage.value)
        ? (_openBlock(), _createBlock(_component_BaseAlert, {
            key: 2,
            variant: "success"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(successMessage.value) + " ", 1),
              _createElementVNode("div", _hoisted_6, [
                (createdBookingId.value)
                  ? (_openBlock(), _createBlock(_component_RouterLink, {
                      key: 0,
                      class: "btn btn-sm",
                      to: {
            name: 'nb_booking_detail',
            params: {
              bookingId: createdBookingId.value,
              facilityId: __props.facilityId,
              facilityName: __props.facilityName,
            },
          }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["to"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (successMessage.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("section", null, [
                _hoisted_11,
                _createElementVNode("dl", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(guestReviewRows(), (row) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: row.label
                    }, [
                      _createElementVNode("dt", null, _toDisplayString(row.label), 1),
                      _createElementVNode("dd", null, _toDisplayString(row.value || "-"), 1)
                    ], 64))
                  }), 128))
                ])
              ]),
              _createElementVNode("section", null, [
                _hoisted_12,
                _createElementVNode("dl", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stayReviewRows(), (row) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: row.label
                    }, [
                      _createElementVNode("dt", null, _toDisplayString(row.label), 1),
                      _createElementVNode("dd", null, _toDisplayString(row.value || "-"), 1)
                    ], 64))
                  }), 128))
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (!successMessage.value)
        ? (_openBlock(), _createElementBlock("form", {
            key: 4,
            class: "booking-form",
            onSubmit: _withModifiers(createBooking, ["prevent"])
          }, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((guestId).value = $event)),
                  type: "text",
                  placeholder: "Leave blank for new guest"
                }, null, 512), [
                  [_vModelText, guestId.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((firstName).value = $event)),
                  type: "text",
                  required: !guestId.value
                }, null, 8, _hoisted_21), [
                  [_vModelText, firstName.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((lastName).value = $event)),
                  type: "text",
                  required: !guestId.value
                }, null, 8, _hoisted_24), [
                  [_vModelText, lastName.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((email).value = $event)),
                  type: "email",
                  required: !guestId.value
                }, null, 8, _hoisted_28), [
                  [_vModelText, email.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((phone).value = $event)),
                  type: "tel",
                  required: !guestId.value
                }, null, 8, _hoisted_31), [
                  [_vModelText, phone.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((addressStreet).value = $event)),
                  type: "text",
                  required: !guestId.value
                }, null, 8, _hoisted_35), [
                  [_vModelText, addressStreet.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _hoisted_38,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((addressCity).value = $event)),
                  type: "text",
                  required: !guestId.value
                }, null, 8, _hoisted_39), [
                  [_vModelText, addressCity.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((addressPostcode).value = $event)),
                  type: "text",
                  required: !guestId.value
                }, null, 8, _hoisted_42), [
                  [_vModelText, addressPostcode.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((addressStateName).value = $event)),
                  type: "text",
                  required: !guestId.value
                }, null, 8, _hoisted_45), [
                  [_vModelText, addressStateName.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((addressCountryName).value = $event)),
                  class: "form-select",
                  required: !guestId.value
                }, [
                  _hoisted_49,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryOptions), (country) => {
                    return (_openBlock(), _createElementBlock("option", { key: country }, _toDisplayString(country), 1))
                  }), 128))
                ], 8, _hoisted_48), [
                  [_vModelSelect, addressCountryName.value]
                ])
              ])
            ]),
            _hoisted_50,
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("div", _hoisted_52, [
                _hoisted_53,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((arrival).value = $event)),
                  type: "date",
                  required: ""
                }, null, 512), [
                  [_vModelText, arrival.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((departure).value = $event)),
                  type: "date",
                  required: ""
                }, null, 512), [
                  [_vModelText, departure.value]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_56, [
              _createElementVNode("div", _hoisted_57, [
                _hoisted_58,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((adults).value = $event)),
                  type: "number",
                  min: "1",
                  required: ""
                }, null, 512), [
                  [
                    _vModelText,
                    adults.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((children).value = $event)),
                  type: "number",
                  min: "0"
                }, null, 512), [
                  [
                    _vModelText,
                    children.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_61, [
                _hoisted_62,
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((animals).value = $event)),
                  type: "number",
                  min: "0"
                }, null, 512), [
                  [
                    _vModelText,
                    animals.value,
                    void 0,
                    { number: true }
                  ]
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-blue",
              type: "submit",
              disabled: submitting.value
            }, _toDisplayString(submitting.value ? "Creating..." : "Create Booking"), 9, _hoisted_63)
          ], 40, _hoisted_13))
        : _createCommentVNode("", true),
      (duplicateGuest.value)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 5,
            "close-label": "Cancel duplicate guest review",
            onModalClosed: cancelDuplicateGuestReview
          }, {
            header: _withCtx(() => [
              _hoisted_64
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_65, [
                _hoisted_66,
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("section", null, [
                    _hoisted_68,
                    _createElementVNode("dl", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newGuestRows(), (row) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: row.label
                        }, [
                          _createElementVNode("dt", null, _toDisplayString(row.label), 1),
                          _createElementVNode("dd", null, _toDisplayString(row.value || "-"), 1)
                        ], 64))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("section", null, [
                    _hoisted_69,
                    _createElementVNode("dl", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(existingGuestRows(duplicateGuest.value), (row) => {
                        return (_openBlock(), _createElementBlock(_Fragment, {
                          key: row.label
                        }, [
                          _createElementVNode("dt", null, _toDisplayString(row.label), 1),
                          _createElementVNode("dd", null, _toDisplayString(row.value || "-"), 1)
                        ], 64))
                      }), 128))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_70, [
                  _createElementVNode("button", {
                    class: "btn",
                    type: "button",
                    disabled: submitting.value,
                    onClick: continueWithNewGuest
                  }, " Create New Guest ", 8, _hoisted_71),
                  _createElementVNode("button", {
                    class: "btn btn-blue",
                    type: "button",
                    disabled: submitting.value,
                    onClick: overwriteExistingGuest
                  }, " Overwrite Existing Guest ", 8, _hoisted_72),
                  _createElementVNode("button", {
                    class: "btn btn-sm",
                    type: "button",
                    disabled: submitting.value,
                    onClick: cancelDuplicateGuestReview
                  }, " Cancel ", 8, _hoisted_73)
                ])
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})